<nz-layout>
    <nz-header class="section-header">
        {{'IPS Data' | translate}}
    </nz-header>
    <nz-content>
        <app-ips-view />
    </nz-content>
</nz-layout>